import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "./../axios";
import React, { useState, useEffect } from "react";
import CurrencyFormat from "react-currency-format";
import { Link, useHistory } from "react-router-dom";
import ProductCart from "../ProductCart";
import { useStateValue } from "../StateProvider";
import "./payment.scss";
import { db } from "../../Config/Config";

const Payment = () => {

  const history = useHistory();
  const [{ basket, user }, dispatch] = useStateValue();

  const getBasketTotal = (basket) =>
    basket?.reduce((amount, item) => item.price + amount, 0);

  const stripe = useStripe();
  const elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState("");


  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(true);


  useEffect(() => {
    
   const getClientSecret = async () =>{
     const response = await axios({
       method: 'post',
       url : `/payments/create?total=${getBasketTotal(basket) *100}`
     });
     setClientSecret(response.data.clientSecret);
   }

   getClientSecret();
  }, [basket])

  const handleSubmit = async (event) => {
    event.preventDefault();

    setProcessing(true);
    const payload = await stripe.confirmCardPayment(clientSecret,{
      payment_method:{
        card:elements.getElement(CardElement)
      }
    }).then(({paymentIntent})=>{
      // paymentIntent = payment Confirmation

      db
      .collection('users')
      .doc(user?.uid)
      .collection('orders')
      .doc(paymentIntent.id)
      .set({
        basket:basket,
        amount: paymentIntent.amount,
        created: paymentIntent.created
      })


      setSucceeded(true);
      setError(null);
      setProcessing(false);

      dispatch({
        type:'EMPTY_BASKET',

      })

      history.replace('/orders');
    })
  };

  const handleChange = (event) => {
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  return (
    <div className="section payment">
      <h4>
        Checkout (<Link to="/checkout">{basket?.length} items</Link>)
      </h4>
      {
        basket.length===0 ? null :
      
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-16 col-xs-12">
            <div className="payment__title">
              <h3>Delivery Address</h3>
            </div>

            <div className="payment__address">
              <h6>{user?.email}</h6>
              <p>Budhanilkantha-10, Jyothinagar, Kapan, Kathmandu, Nepal</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="payment__title">
              <hr />
              <h3>Review items and delivery</h3>
              <hr />
            </div>

            <div className="payment__address">
              {basket.map((item) => (
                <ProductCart
                  id={item.id}
                  title={item.title}
                  image={item.image}
                  rating={item.rating}
                  price={item.price}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 my-4">
            <div className="payment__title">
              <h3>Payment Method</h3>
            </div>

            <div className="payment__details">
              <form onSubmit={handleSubmit}>
                <CardElement onChange={handleChange} />

                <div className="payment__priceDetails">
                  <CurrencyFormat
                    renderText={(value) => (
                      <>
                       <h5 style={{"marginTop": "10px"}}>Order Total : { value }</h5>
                      </>
                    )}
                    decimalScale={2}
                    value={getBasketTotal(basket)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </div>

                <button className="addtocart__btn mb-4"  disabled={processing || disabled || succeeded}>
                    <span style={{color:"#fff"}}>{processing ? <p>Processing</p> :  "Buy Now"}</span>
                </button>

                {error && <div>{error}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
};

export default Payment;
